import styled from '@emotion/styled'

export const AttributeDescriptionContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})
